import React from "react";

function VerticalSeparator() {
  return (
    <div
      className="w-[1px] h-[34px] mx-[15px] "
      style={{ backgroundColor: "#F1F5F9" }}
    ></div>
  );
}

export default VerticalSeparator;
